import 'antd';
import { styled } from 'styled-components';

export const Label = styled.div({});

export const Value = styled.div({});

export const Container = styled.div<{
  highlight?: boolean;
  size?: 'large' | 'small';
}>(({ theme }) => ({
  textAlign: 'right',
  display: 'grid',
  gap: '8rem',
  gridTemplateColumns: '2fr 1fr',
  '&[data-color="green"]': {
    color: theme.palette.green,
  },
  '&[data-color="red"]': {
    color: theme.palette.red,
  },
  [`${Value}, ${Label}`]: {
    fontSize: theme.typography.size14,
    '&:only-child': {
      gridColumn: '1 / -1',
    },
  },
  '&[data-size="large"]': {
    [`${Value}, ${Label}`]: {
      fontSize: theme.typography.size20,
    },
  },

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));
